export class CreateCandidateSalaryClass {
    basicSalary?: number;
    upperSalary?: number;
    currency?: string;
    perriod?: string;
}
